module.exports = __webpack_public_path__ + "static/media/spinner_1.1b39dbef.gif";